import { createGlobalStyle } from "styled-components";

interface StyleProps {
  deviceType?: string;
}

export const CurrencyRatePageStyle = createGlobalStyle<StyleProps>`

html,
body {
  background: #f6f6f6;
  padding: 0;
  margin: 0;
  color: #4a4a4a;
  font-size: 14px;
  font-family: lato;
  font-weight: 400;
}
html {
  box-sizing: border-box;
}

*,
*:before,
*:after {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  -webkit-font-smoothing: antialiased;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
ul {
  margin: 0;
  list-style: none;
  padding: 0;
}
a {
  color: #008cff;
  text-decoration: none;
  cursor: pointer;
}
a:hover,
a:focus {
  text-decoration: none;
  outline: none;
}
img {
  max-width: 100%;
}


/* Global */
.mt10{
    margin-top: 10px;
}
.mt20{
    margin-top: 20px;
}
.h2{
    font-size: 36px;
    line-height: 44px;
    font-weight: 900;
    color: #000;
}
.h3{
    font-size: 24px;
    line-height: 40px;
    font-weight: 900;
    color: #000;
}
.description{
    font-size: 18px;
    line-height: 24px;
    color: #000;
}

/* Page container wrapper styles - controlled by component logic */
.pageContainerWrapper {
  width: 100%;
}

.pageContainerWrapper--large {
  background-color: #F2F2F2;
  min-height: 100vh;
}

.pageContainerWrapper--small {
  background-color: transparent;
  min-height: auto;
}

/* Desktop styles - all desktop-specific overrides */
@media (min-width: 1024px) {
  ${(props) =>
    props.deviceType === "lg"
      ? `
    /* Typography overrides */
    .h2{
        font-size: 32px;
        line-height: 40px;
    }
    .description{
        font-size: 16px;
        line-height: 22px;
    }
    
    /* Update other 18px text to 16px for desktop */
    .getForex__title .big,
    .getForex__title .small,
    .getForex__title .medium,
    .getForex__listItemDesc p.title,
    .getForex__listItemDesc h3.title,
    .planTrip p,
    .ccList__item p.heading,
    .ccList__item h4.heading,
    .benifitsList li,
    .bestRate li,
    .ccList__item div.desc,
    .conversionTbl th,
    .conversionTbl td,
    .faqList li div.answer,
    .faqList li h4.question {
        font-size: 16px;
        line-height: 22px;
    }
    
    /* Specific typography for conversion rate headings */
    .conversionRate_heading {
        font-size: 18px !important;
        line-height: 22px !important;
        font-weight: 900 !important;
        margin-bottom: 16px !important;
        color: #000 !important;
    }
    
    /* Update specific elements that need different line heights */
    .ccList__item p.heading,
    .ccList__item h4.heading {
        line-height: 24px;
    }
    
    .faqList li h4.question {
        line-height: 26px;
    }
    .sectionWrapper {
        background-color: #fff;
        border-radius: 16px;
        padding: 32px 24px;
        margin-bottom: 24px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    
    .sectionWrapper:last-child {
        margin-bottom: 0;
    }
    
    /* Remove pageContent margin for desktop to prevent empty space */
    .pageContent {
        margin: 0 auto;
    }
    
    /* Hide separators on desktop by default */
    .separator {
        display: none !important;
    }

    /* Show dotted separator only between description.mt10 and benifitsList (WhyToBuy and HowToBuy sections) */
    .description.mt10 + .separator {
        display: block !important;
        height: 1px !important;
        background: none !important;
        border: none !important;
        border-top: 1px dashed #D8D8D8 !important;
        margin: 24px 0 !important;
        width: 100% !important;
    }
    
    /* Ensure top banner doesn't create empty space */
    #top-banner {
        min-height: auto;
        padding: 0;
        margin: 0;
    }
    
    /* Remove any unwanted margins from first section */
    .pageContent > .sectionWrapper:first-child {
        margin-top: 0;
    }
    
    /* Ensure no empty space before first content */
    .pageContent {
        padding-top: 0;
    }
    
    /* Popular Denominations section improvements */
    .conversionRate {
        margin-top: 0;
        gap: 40px;
    }
    
    .conversionTbl {
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        background-color: #fff;
    }
    
    .conversionTbl th {
        padding: 16px 20px !important;
        font-size: 16px !important;
        font-weight: 700 !important;
        background-color: #16477F !important;
        color: #fff !important;
        border: none !important;
        text-align: center !important;
    }
    
    .conversionTbl th h3 {
        font-size: 16px !important;
        font-weight: 900 !important;
        color: #fff !important;
        margin: 0 !important;
    }
    
    .conversionTbl td {
        padding: 12px 20px !important;
        font-size: 20px !important;
        font-weight: 900 !important;
        color: #000 !important;
        border-bottom: 1px solid #e0e0e0 !important;
        background-color: #fff !important;
        border-left: none !important;
        border-right: none !important;
        border-top: none !important;
        text-align: center !important;
    }
    
    .conversionTbl tbody tr:last-child td {
        border-bottom: none !important;
    }
    
    .conversionTbl td a {
        color: #008CFF !important;
        text-decoration: none !important;
        font-weight: 900 !important;
    }
    
    .conversionTbl td a:hover {
        text-decoration: underline !important;
    }
     
           /* Other Conversions section - capSulesList styles for lg deviceType */
      .capSulesList,
      .capSulesList.grid5,
      .capSulesList.grid4 {
          display: grid !important;
          grid-template-columns: repeat(4, 1fr) !important;
          gap: 16px !important;
          margin-top: 32px !important;
      }
     
     .capSulesList li {
         padding: 16px 20px;
         border-radius: 8px;
         background-color: #F6F6F6 !important;
         border: none;
         box-shadow: none;
         cursor: pointer;
         text-align: center;
         transition: all 0.2s ease;
     }
     
     .capSulesList li:hover {
         background-color: #E8E8E8;
     }
     
     .capSulesList li a {
         color: #008CFF !important;
         font-size: 12px !important;
         font-weight: 900 !important;
         text-decoration: none !important;
         display: block;
         line-height: 1.4;
     }
     
     .capSulesList li a:hover {
         text-decoration: none !important;
     }
     
     .viewMore {
         margin-top: 24px;
         text-align: left;
     }
     
     .viewMore__cta {
         color: #008CFF !important;
         font-size: 16px !important;
         font-weight: 700 !important;
         cursor: pointer;
         text-decoration: none !important;
     }
     
     .viewMore__cta:hover {
         text-decoration: underline !important;
     }
     
     /* Top Reviewed Currencies section - currencyList styles for lg deviceType */
     .currencyList {
         display: grid;
         grid-template-columns: repeat(4, 1fr) !important;
         gap: 16px;
         margin-top: 32px;
         width: 100%;
     }
     
     .currencyList li {
         width: 100%;
         display: flex;
     }
     
     .currencyList li a {
         padding: 16px 20px;
         border-radius: 16px !important;
         background-color: #FFFFFF !important;
         border: 1px solid #D8D8D8 !important;
         box-shadow: none !important;
         cursor: pointer;
         display: flex;
         flex-direction: row;
         align-items: center;
         justify-content: flex-start;
         text-decoration: none;
         transition: all 0.2s ease;
         min-height: 64px;
         color: #008CFF !important;
         font-size: 18px !important;
         font-weight: 700 !important;
         line-height: 22px !important; /* 1.2em of 18px rounded */
         width: 100%;
         box-sizing: border-box;
     }
     
     .currencyList li a:hover {
         background-color: #F8F8F8;
         border-color: #008CFF;
         text-decoration: none;
     }
     
     .currency__icon {
         width: 48px !important;
         height: 48px !important;
         flex-shrink: 0;
         margin-right: 12px !important;
         display: flex;
         align-items: center;
         justify-content: center;
     }
     
     .currency__icon img {
         width: 48px !important;
         height: 48px !important;
         object-fit: contain;
     }
     
    /* FAQ section styles for lg deviceType */
     .faqList {
         margin-top: 16px !important;
     }
    
     .faqList li h4.question {
        font-size: 16px !important;
        line-height: 16px !important;
        padding: 12px 0px !important;
        font-weight: 400 !important;
     }
    
     .faqList li h4.question::after {
         top: 12px !important;
      }
      
      .faqList li:hover {
          box-shadow: none !important;
          border-color: transparent !important;
          background-color: transparent !important;
      }
      
      .faqList li:hover h4.question {
          background-color: transparent !important;
          box-shadow: none !important;
          border-radius: none !important;
      }
    
      .faqList li div.answer {
          font-size: 14px !important;
          margin-bottom: 16px !important;
      }

    /* Update benifitsList li::before gradient for lg deviceType */
    .benifitsList li::before {
        background-image: linear-gradient(to bottom, #16477F, #16477F) !important;
    }

    /* Update bestRate li styling to match Figma specifications for lg deviceType */
    .bestRate li {
        font-size: 16px !important;
        line-height: 19.2px !important; /* 1.2em of 16px */
        font-weight: 400 !important;
        color: #4A4A4A !important;
        margin-bottom: 18px !important;
    }

    /* Update WhyToBuy section styling to match Figma specifications for lg deviceType */
    .description {
        font-size: 16px !important;
        line-height: 19.2px !important; /* 1.2em of 16px */
        font-weight: 400 !important;
        color: #4A4A4A !important;
    }

    .benifitsList li {
        font-size: 16px !important;
        line-height: 19.2px !important; /* 1.2em of 16px */
        font-weight: 400 !important;
        color: #4A4A4A !important;
        margin-bottom: 15px !important;
        padding-left: 25px !important;
    }

    /* Fix h3 styling for CurrencyInformation section */
    .h3 {
        font-size: 22px !important;
        line-height: 26.4px !important; /* 1.2em of 22px */
        font-weight: 900 !important;
        color: #000 !important;
    }

    /* Fix explore button styling to match Figma */
    .exploreBtn {
        width: 120px !important;
        height: 32px !important;
        padding: 12px 16px !important;
        background: linear-gradient(135deg, rgba(83, 178, 254, 1) 0%, rgba(6, 90, 243, 1) 100%) !important;
        border-radius: 8px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        margin: 24px 0 !important;
        cursor: pointer !important;
        box-sizing: border-box !important;
    }

    .exploreBtn_text {
        font-size: 12px !important;
        line-height: 14.4px !important; /* 1.2em of 12px */
        font-weight: 900 !important;
        color: #fff !important;
        text-align: center !important;
        text-transform: uppercase !important;
    }

    /* Top banner section styling for lg deviceType */
    #top-banner {
        background: url(//imgak.mmtcdn.com/pwa_v3/pwa_commons_assets/desktop/bg6.jpg) !important;
        background-repeat: no-repeat !important;
        padding-bottom: 40px !important;
        min-height: auto !important;
        padding: 0 !important;
        margin: 0 !important;
    }

    .top-banner__container {
        margin: 0 auto !important;
        padding-top: 32px !important;
        max-width: 1200px !important;
    }

    .top-banner__wrapper {
        padding-bottom: 40px;
        padding-top: 16px;
    }

    .top-banner__title {
        font-size: 36px !important;
        line-height: 43.2px !important; /* 1.2em of 36px */
        font-weight: 900 !important;
        color: #FFFFFF !important;
        margin: 0 !important;
    }

    .top-banner__breadcrumb {
        margin-top: 16px !important;
    }

//     /* Add down arrow to Show More section for lg deviceType only */
//     .viewMore__cta {
//         display: inline-flex !important;
//         align-items: center !important;
//         gap: 4px !important;
//     }

//     .viewMore__cta::after {
//         content: "";
//         width: 0;
//         height: 0;
//         border-left: 4px solid transparent;
//         border-right: 4px solid transparent;
//         border-top: 5px solid #008CFF;
//         transition: transform 0.2s ease;
//     }

//     /* Rotate arrow when expanded (Show Less state) */
//     .showAll .viewMore__cta::after {
//         transform: rotate(180deg);
//     }
//   `
      : ""}
}

.description span{
    font-weight: 900;
}

header{
    background-color: #fff;
    position: sticky;
    top: 0;
    z-index: 10;
    padding: 18px 0;
}
.headerInner{
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.header__right{
    display: flex;
    align-items: center;
    margin-left: auto;
}
.topNav{
    display: flex;
}
.topNav li{
    margin-right: 30px;
}
.topNav li a{
    color: #fff;
}
.loginBtn{
    display: inline-flex;
    border-radius: 30px;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: 700;
    color: #008cff;
    outline: 0;
    border: 0;
    cursor: pointer;
    font-family: 'Lato';
}
/* Top Section */
.heroSection{
    background: #000;
}
.heroSection__inner{
    max-width: 1200px;
    margin: 0 auto;
    background: url('https://tripmoneycmsimgak.mmtcdn.com/img/hero_bg_2e6e787a77.png') top right no-repeat;
    background-size: 557px 155px;
    padding: 40px 0 80px 0;
}
.breadCrumb{
    display: flex;
}
.breadCrumb li{
    font-size: 14px;
    font-weight: 700;
}
.breadCrumb li::after{
    content: "";
    display: inline-block;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    padding: 2px;
    transform: rotate(-45deg);
    margin: 0 10px;
}
.breadCrumb li:last-child:after{
    display: none;
}
.breadCrumb li a{
    color: #fff;
}
.breadCrumb li:last-child a{
    pointer-events: none;
}
.heroContent{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 75px;
}
.heroContent__left{
    width: 460px;
    flex-shrink: 0;
}
.heroContent__left h1{
    font-size: 45px;
    line-height: 52px;
    font-weight: 900;
    color: #fff;
}
.heroContent__left .h1 {
    font-size: 45px;
    line-height: 52px;
    font-weight: 900;
    color: #fff;
}

h1.inline {
    display: inline;
}
.heroContent__left p{
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
    color: #fff;
    margin-top: 5px;
}

.hero_cashback {
    margin-top: 35px;
    padding: 10px 24px;
    background-image: linear-gradient(to bottom, #f2fffc, #dbfff4);
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    width: 100%;
}

.hero_cashback img {
    height: 44px;
    width: 44px;
}

.hero_cashback_text p {
    font-size: 20px;
    color: #000;
    font-weight: 400;
}

.heroContent_container {
 max-width: 390px;
}

.exchange{
    background-color: #3d3d3d;
    border-radius: 4px;
    padding: 10px 20px;
    font-size: 22px;
    color: #85e5be;
    display: inline-flex;
    margin-top: 25px;
    width: 100%;
}
.exchange span{
    font-weight: 900;
}
.heroContent__right{
    width: 560px;
    flex-shrink: 0;
    background-color: #fff;
    padding: 25px;
    border-radius: 12px;
}
.heroContent__title{
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 30px;
    font-weight: 400;
    color: #000;
}
.heroContent__option{
    display: flex;
}
.heroContent__option .radioBox:first-child{
    margin-right: 40px;
}
.optionText{
    font-size: 12px;
    font-weight: 700;
    color: #757575;
    text-transform: uppercase;
}
.radioBox [type="radio"]:checked + label.optionText{
    color: #008cff;
}
.inputContainer{
    display: flex;
    margin-top: 20px;
}
.inputContainer__col{
    flex: 1;
}
.inputContainer__separator{
    flex-shrink: 0;
    margin: 0 13px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.form-group {
    position: relative;
}
.form-group input {
    width: 100%;
    padding: 18px 12px 10px 12px;
    border: 1px solid #e2e2e2;
    border-radius: 2px;
    font-size: 14px;
    font-weight: 700;
    font-family: 'Lato';
    color: #000000;
    background-color: #f6f6f6;
    transition: border-color 0.3s ease;
}
.form-group label {
    position: absolute;
    left: 12px;
    top: 17px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: #757575;
    transition: top 0.3s ease, font-size 0.3s ease, color 0.3s ease;
}
.form-group input:focus {
    outline: none;
}
.form-group input:focus + label,
.form-group input:not(:placeholder-shown) + label {
    top: 5px;
}
.btnSubmit{
    background-color: #280e0e;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 900;
    color: #fff;
    text-transform: uppercase;
    font-family: 'Lato';
    outline: 0;
    border: 0;
    cursor: pointer;
    margin-top: 30px;
    width: 100%;
}


.floatingSelect {
    position: relative;
    margin-top: 25px;
}
.floatingSelect::after {
    content: "";
    border: solid #008cff;
    border-width: 0 2px 2px 0;
    padding: 3px;
    position: absolute;
    right: 15px;
    top: 17px;
    transform: rotate(45deg);
    pointer-events: none;
}

.floatingSelect__label {
    color: #757575;
    font-size: 12px;
    font-weight: 700;
    position: absolute;
    pointer-events: none;
    left: 12px;
    top: 16px;
    text-transform: uppercase;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.floatingSlctBox {
    font-size: 12px;
    display: block;
    font-weight: 700;
    font-family: 'Lato';
    width: 100%;
    height: 48px;
    padding: 14px 12px 0 12px;
    border-radius: 2px;
    background-color: #f6f6f6;
    border: 1px solid #e2e2e2;
    outline: 0;
    box-sizing: border-box;
}
.floatingSlctBox:focus {
    outline: none;
}
.floatingSlctBox:focus ~ .floatingSelect__label {
    top: 5px;
}

select.floatingSlctBox {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

select.floatingSlctBox::-ms-expand {
    display: none;
}

.floatingSlctBox:not([value=""]):valid ~ .floatingSelect__label {
    top: 5px;
}

.floatingSlctBox[value=""]:focus ~ .floatingSelect__label {
    top: 5px;
}

.pageContainer{
    max-width: 1200px;
    margin: 56px auto;
}
.getForex{
    padding: 56px 24px 44px;
    border-radius: 10px;
    background-color: #fff;
}
.getForex__title{
    margin-bottom: 40px;
}
.getForex__title .big{
    font-size: 18px;
    color: #000;
    font-weight: 700;
    margin-right: 10px;
}
.getForex__title .small{
    font-size: 18px;
    color: #4a4a4a;
    font-weight: 400;
}
.getForex__title .medium{
    font-size: 18px;
    color: #2b825e;
    font-weight: 900;
}
.getForex__list{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}
.getForex__listItem{
    border: solid 1px #e2e2e2;
    padding: 10px 13px;
    border-radius: 4px;
    display: flex;
}
.getForex__listItemImg{
    width: 140px;
    flex-shrink: 0;
    margin-right: 10px;
}
.getForex__listItemDesc{
    flex: 1;
}
.getForex__listItemDesc h3.title{
    font-size: 18px;
    font-weight: 900;
    color: #000;
    display: flex;
    align-items: center;
}
.getForex__listItemDesc p.title{
    font-size: 18px;
    font-weight: 900;
    color: #000;
    display: flex;
    align-items: center;
}
.getForex__listItemDesc h3.title .arrow{
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: 10px;
    position: relative;
}
.getForex__listItemDesc h3.title .arrow::after{
    content: "";
    display: inline-block;
    border: solid #008cff;
    border-width: 0 2px 2px 0;
    padding: 3px;
    transform: rotate(-45deg);
    position: absolute;
    right: 2px;
    top: 4px;
}
.getForex__listItemDesc h3.title .arrow::before{
    content: "";
    display: inline-block;
    width: 10px;
    height: 2px;
    background-color: #008cff;
    position: absolute;
    right: 3px;
    top: 7px;
}
.getForex__listItemDesc p.desc{
    font-size: 14px;
    line-height: 22px;
    margin-top: 10px;
}
.getForex__listItemDesc p.desc span{
    position: relative;
    padding: 0 5px 0 10px;
}
.getForex__listItemDesc p.desc span::after{
    width: 4px;
    height: 4px;
    background-color: #2b825e;
    content: "";
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 8px;
}
.getForex__listItemDesc p.desc span:first-child::after{
    display: none;
}
.getForex__listItemDesc p.desc span:first-child{
    padding: 0 5px 0 0;
}
.deliveryBy{
    font-size: 12px;
    font-weight: 700;
    color: #2b825e;
    margin-top: 8px;
    display: none;
    align-items: center;
}
.deliveryBy img{ width: 8px; flex-shrink: 0; margin-right: 5px;}
.pageContent{
    margin: 20px auto 35px;
}
.offer_banner{
    margin-bottom: 36px;
    cursor: pointer;
}
.offer_banner .offer_bannerDt {
    width: 100%;
    height: 253px;
    object-fit: contain;
}
.offer_banner .offer_bannerMobile {
    width: 100%;
    height: 340px;
    object-fit: contain;
    display: none;
}
.planTrip{
    margin-bottom: 28px;
}
.planTrip p{
    font-size: 18px;
    line-height: 24px;
    color: #000;
}
.planTrip p span{
    font-weight: 900;
}

.convertCurrency{
    padding: 48px 60px;
    border-radius: 8px;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);
    background-color: #fff;
    margin-top: 30px;
}
.ccList__item{
    border-bottom: 1px #c7c7c7 dashed;
    padding: 36px 25px;
}
.ccList__item:first-child{
    padding-top: 0;
}
.ccList__item:last-child{
    padding-bottom: 0;
    border-bottom: 0;
}
.ccList__item h4.heading{
    font-size: 24px;
    line-height: 26px;
    color: #2f2f2f;
    font-weight: 900;
    position: relative;
}
.ccList__item p.heading{
    font-size: 24px;
    line-height: 26px;
    color: #2f2f2f;
    font-weight: 900;
    position: relative;
}
.ccList__item p.heading::before{
    content: "";
    width: 7px;
    height: 19px;
    border-radius: 4px;
    background-image: linear-gradient(to bottom, #b68f38, #e5cf8b);
    position: absolute;
    left: -25px;
    top: 4px;
}
.ccList__item div.desc{
    font-size: 18px;
    line-height: 24px;
    color: #000;
    margin-top: 13px;
}
.ccList__item p.desc span{
    font-weight: 900;
}

.bestRate {
    margin-top: 20px;
}

.bestRate li{
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 18px;
    color: #000;
}

.benifitsList{
    margin-top: 20px;
}
.benifitsList li{
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 15px;
    color: #000;
    padding-left: 25px;
    position: relative;
}
.benifitsList li span{
    font-weight: 900;
}
.benifitsList li::before{
    content: "";
    width: 7px;
    height: 15px;
    border-radius: 4px;
    background-image: linear-gradient(to bottom, #b68f38, #e5cf8b);
    position: absolute;
    left: 0;
    top: 5px;
}

.forexServices{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-top: 26px;
}
.forexServices__item{
    border-radius: 8px;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);
    background-color: #fff;
    padding: 25px;
}
.forexServices__itemHdr{
    display: flex;
    margin-bottom: 15px;
    align-items: center;
}
.forexServices__itemImg{
    flex-shrink: 0;
    margin-right: 15px;
}
.forexServices__itemTitle{
    font-size: 28px;
    line-height: 32px;
    color: #000;
    font-weight: 900;
}

.conversionRate{
    margin-top: 50px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 67px;
}
.statsTableWrapper {
    border: 1px #979797 solid;
}
.statsTableHeader {
    background-color: #000000;
    padding: 20px 40px;
    align-items: center;
}
.statsTableHeader p {
    font-size: 18px;
    line-height: 22px;
    color: #fff;
    font-weight: 900;
    text-align: center;
}
.statsTable th{
    border-bottom: 1px #979797 solid;
    padding: 12px;
    text-align: center;
    font-size: 18px;
    font-weight: 800;
    color: #000;
}
.statsTable td{
    padding: 12px;
    text-align: center;
    font-size: 18px;
    color: #000;
}
.statsTable tbody tr:not(:last-child) td{  
    border-bottom: 1px #979797 solid;
}
.statsTable tbody td:not(:last-child){  
    border-right: 1px #979797 solid;
}
.statsTable thead th:not(:last-child){  
    border-right: 1px #979797 solid;
}
.conversionRate_heading {
    font-size: 28px;
    font-weight: 900;
    color: #000;
    line-height: 32px;
    margin-bottom: 24px;
}    
.conversionTbl{
    border-collapse: collapse;
    width: 100%;
}
.conversionTbl th{
    padding: 20px 40px;
    background-color: #000000;
    font-size: 18px;
    font-weight: 900;
    color: #fff;
    text-align: left;
    border: 1px #979797 solid;
}
.conversionTbl td{
    padding: 14px 40px;
    font-size: 18px;
    color: #000;
    border: 1px #979797 solid;
    background-color: #fff;
}

.conversionTbl td.stateBg{
    background-color: #f6f6f6;
}
.states{
    margin-top: 47px;
}
.capSulesList{
    display: grid;
    margin-top: 30px;
    gap: 15px;
}
.capSulesList.grid5{
    grid-template-columns: repeat(5, 1fr);
}
.capSulesList.grid4{
    grid-template-columns: repeat(4, 1fr);
}
.capSulesList li{
    padding: 19px;
    border-radius: 6px;
    cursor: pointer;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);
    background-color: #fff;
    font-size: 16px;
    font-weight: 700;
    color: #005cbc;
    text-align: center;
}
.capSulesList li:nth-child(n+5){
    display: none;
}
.capSulesList.showAll li:nth-child(n+5){
    display: block;
}

.viewMore{
    margin-top: 30px;
}
.viewMore__cta{
    font-size: 16px;
    font-weight: 700;
    color: #005cbc;
}

.exploreBtn{
    padding: 10px 16px; 
    background-color: #008cff;
    border-radius: 20px;
    display: inline-block;
    margin: 26px 0px;
    cursor: pointer;
}

.exploreBtn_text{
    font-size: 16px;
    font-weight: 900;
    color: #fff;
    text-align: center;
}


.separator{
    height: 1px;
    background-color: #979797;
    margin: 50px 0;
}

.faqList{
    margin-top: 50px;
}
.answer{
    display:none;
}
.toggleAnswer .answer{
    display:block;
}
.faqList li h4.question{
    font-size: 24px;
    line-height: 26px;
    font-weight: 900;
    color: #000;
    padding: 30px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    position: relative;
}
.faqList li h4.question::after{
    content: "";
    border: solid #2f2f2f;
    display: inline-block;
    border-width: 0 3px 3px 0;
    padding: 6px;
    transform: rotate(45deg);
    position: absolute;
    right: 40px;
    top: 32px;
}
.faqList li div.answer{
    font-size: 18px;
    line-height: 24px;
    color: #000;
    padding: 0 0 0 30px;
    margin-bottom: 30px;
}
.faqList li div.answer span{
    font-weight: 900;
}
.faqList li:hover h4.question{
    border-radius: 6px;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);
    background-color: #fff;
}
.faqList li.active h4.question::after{
    transform: rotate(-135deg);
    top: 42px;
}


.currencyList{
    display: grid;
    gap: 15px;
    margin-top: 30px;
}

.currencyList.grid5{
    grid-template-columns: repeat(5, 1fr);
}
.currencyList.grid4{
    grid-template-columns: repeat(4, 1fr);
}

.currencyList li a{
    padding: 19px;
    border-radius: 6px;
    cursor: pointer;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22);
    background-color: #fff;
    font-size: 16px;
    font-weight: 700;
    color: #005cbc;
    align-items: center;
    display: flex;
    flex-direction: row;
    text-decoration: underline;

}
.currencyList li:nth-child(n+5){
    display: none;
}
.currencyList.showAll li:nth-child(n+5){
    display: block;
}
.currency__icon{
    width: 65px;
    flex-shrink: 0;
    margin-right: 14px;
}
footer{
    background-color: #16223e;
    padding: 50px 0 30px 0;
}
.footer__cont{
    max-width: 1200px;
    margin: 0 auto;
}
.footer__hdr{
    padding: 3px 0;
    background-color: #4f4f4f;
    font-size: 14px;
    font-weight: 900;
    color: #fff;
    text-align: center;
    margin-bottom: 40px;
}

.footernavCont{
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 40px;
}
.footerNavTitle{
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    margin-bottom: 10px;
}
.footerNavList li{
    margin-bottom: 8px;
}
.footerNavList li a{
    color: #d8d8d8;
    font-size: 12px;
}
.footerBottom{
    border-top: 1px #707070 solid;
    margin-top: 40px;
    padding: 20px 0 0 0;
    text-align: center;
}

.container {
    max-width: 1100px;
    margin: 0 auto;
    font-size: 18px;
    line-height: 22px;
  }
.reviewedCurrencies {
    background-color: #e0e0e0;
    padding: 46px 0;
  }

  .reviewedCurrencies .container {
    display: flex;
    justify-content: space-between;
    margin-top: 0;
  }

  .footerLink{
    padding:6px 0;
  }

  .footerLinkCol{
        margin-left: 26px;
  }

  footer .linkTitle {
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 20px;
  }

  footer .container {
    display: flex;
    justify-content: space-between;
    margin-top: 0;
    color: #fff;
    font-size: 16px;
  }

  footer a {
    color: #fff;
  }
  
  .footerLinkCol:first-child{
    margin-left: 0;
  }

  .reviewedCurrencies h3{
    font-size:28px;
    margin-bottom: 16px;
  }

/*-- Radio Box --*/
.radioBox {
    display: inline-flex;
    position: relative;
  }
  .radioBox [type="radio"]:checked,
  .radioBox [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }
  .radioBox [type="radio"]:checked + label,
  .radioBox [type="radio"]:not(:checked) + label {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-flex;
  }
  .radioBox [type="radio"]:checked + label:before,
  .radioBox [type="radio"]:not(:checked) + label:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 1px solid #9b9b9b;
    border-radius: 100%;
    background: #fff;
  }
  .radioBox [type="radio"]:checked + label:before {
    border: 1px solid #008cff;
  }
  .radioBox [type="radio"]:checked + label:after,
  .radioBox [type="radio"]:not(:checked) + label:after {
    content: "";
    width: 12px;
    height: 12px;
    background: #008cff;
    position: absolute;
    top: 3px;
    left: 3px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  .radioBox [type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  .radioBox [type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }


  /* New Styles - header.html */
 .heroSection__inner.heroPadding {
    padding: 0 16px 200px 16px;
  }

  .heroSection .heroSection_info {
    padding: 38px 0 0;
  }

  .heroPadding h2{
    font-size: 45px;
    line-height: 52px;
    font-weight: 900;
    color: #fff;
  }

  .heroPadding p{
    font-size: 22px;
    line-height: 52px;
    font-weight: 600;
    line-height: 30px;
    color: #fff;
    margin-top: 10px;
  }

  .pageContainer.pageContainer_margin {
    margin: 0 auto;
    margin-top: -170px;
  }

  @media (min-width: 320px) and (max-width: 767px) {
    .heroPadding h2{
        font-size: 24px;
        line-height: 28px;
    }
    .heroPadding p{
        font-size: 16px;
        line-height: 20px;
    }
  }

  /* Mobile devices */
@media (min-width: 320px) and (max-width: 767px) {
    body{ background-color: #ffffff;}
    .header__right{ display: none;}
    .headerInner{ justify-content: center; align-items: center;}
    .heroSection__inner{ 
        padding: 0 12px 30px 12px; 
        background: url('https://tripmoneycmsimgak.mmtcdn.com/img/hero_bg_mob_bffdba7329.png') top center no-repeat;
        background-size: 320px 167px;
    }
    .heroContent{ flex-direction: column; margin-top: 32px;}
    .heroContent__left{ width: 100%; display: flex; flex-direction: column;}
    .heroContent__right{ width: 100%; padding: 20px 16px 30px 16px;}
    .heroContent__left h1{ font-size: 28px; line-height: 32px; text-align: center;}
    .heroContent__left .h1{ font-size: 28px; line-height: 32px; text-align: center;}
    .heroContent__left p{ font-size: 14px; line-height: 18px; text-align: center;}
    .heroContent_container{padding: 0px 20px; max-width: 100%;}
    .exchange{ font-size: 15px; margin-left: auto; margin-right: auto; margin-bottom: 9px; padding: 15px 25px; width: 100%;}
    .hero_cashback {
        margin-bottom: 25px;
        margin-top: unset;
        margin-left: auto; margin-right: auto;
        width: 100%;
    }

    .hero_cashback img {
        height: 30px;
        width: 30px;
    }

    .hero_cashback_text p {
        text-align: left;
        font-size: 16px;
        color: #000;
        font-weight: 400;
    }
    .offer_banner{
        margin-bottom: 30px;
    }
    .offer_banner .offer_bannerDt {
        display: none;
    }
    .offer_banner .offer_bannerMobile {
        display: block;
    }
    .exploreBtnWrap{ display: flex; justify-content: center;}
    .currencyList li a{padding: 10px;}
    .currency__icon{ width: 43px; margin-right: 10px;}
    .currency__icon > img{ width: 43px !important; height: 43px !important;}
    .h2{ font-size: 30px; line-height: 34px;}
    .h3{ font-size: 20px; line-height: 24px;}
    .pageContainer{ padding: 0 12px; margin: 30px auto;}
    .getForex{ box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.16); border: solid 1px #e8e8e8; padding: 25px 12px; border-radius: 12px;}
    .getForex__title{ display: none;}
    .getForex__list{ grid-template-columns: 1fr;}
    .getForex__listItem{ border: 0; padding: 0; border-radius: 0;}
    .getForex__listItem:first-child{ border-bottom: 1px #f2f2f2 solid; padding-bottom: 15px;}
    .getForex__listItemImg{ width: 64px;}
    .getForex__listItemImg img{ width: 64px; height: unset;}
    .getForex__listItemDesc p.desc{ margin-top: 5px; font-size: 12px; line-height: 18px;}
    .getForex__listItemDesc p.desc span::after{ top: 6px;}
    .getForex__listItemDesc p.title .arrow{ margin-left: auto;}
    .deliveryBy{ display: flex;}
    .planTrip p{ font-size: 16px; line-height: 24px;}
    .description{ font-size: 16px; line-height: 24px;}
    .separator{ margin: 30px 0;}
    .convertCurrency{ padding: 30px 20px;}
    .ccList__item p.heading{ font-size: 18px; line-height: 22px;}
    .ccList__item p.desc{ font-size: 16px; line-height: 24px;}
    .ccList__item{ padding: 16px 20px;}
    .benifitsList li{ font-size: 16px;}
    .forexServices{ display: flex; gap: unset; flex-wrap: nowrap; overflow-x: auto; padding: 6px 12px; margin: 20px -12px 0px -12px;}
    .forexServices::-webkit-scrollbar{ display: none;}
    .forexServices__item{ width: 258px; flex-shrink: 0; margin-right: 12px; padding: 20px 20px 20px 29px;}
    .forexServices__itemHdr{ flex-direction: column; margin-bottom: 10px;}
    .forexServices__itemImg{ margin-right: 0;}
    .forexServices__itemImg img{ width: 102px; height: auto;}
    .forexServices__itemTitle{ max-width: unset; font-size: 18px; line-height: 22px; margin-top: 10px;}
    .conversionRate{ grid-template-columns: 1fr; gap: 26px; margin-top: 30px;}
    .conversionRate_heading{font-size: 18px; line-height: 22px; margin-bottom: 20px;}
    .conversionTbl th{ padding: 14px 25px; font-size: 16px;}
    .conversionTbl td{ padding: 14px 25px; font-size: 16px;}
    .statsTable th {font-size: 16px;}
    .statsTable td {font-size: 16px;}
    .states{ margin-top: 30px;}
    .capSulesList.grid5, .capSulesList.grid4{ 
        grid-template-columns: repeat(2, 1fr) !important; 
        gap: 10px !important;
    }
    .currencyList.grid5, .currencyList.grid4{ 
        grid-template-columns: repeat(2, 1fr) !important; 
        gap: 10px !important;
    }
    .currencyList {
        margin-top: 20px !important;
    }
    .currencyList li a {
        padding: 10px !important;
        background-color: #fff !important;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22) !important;
        font-size: 16px !important;
        font-weight: 700 !important;
        color: #005cbc !important;
        border-radius: 6px !important;
        border: none !important;
        min-height: auto !important;
    }
    .currency__icon { 
        width: 43px !important; 
        margin-right: 10px !important;
    }
    .currency__icon img { 
        width: 43px !important; 
        height: 43px !important;
    }
    .capSulesList{ 
        margin-top: 20px !important;
    }
    .capSulesList li {
        padding: 19px !important;
        border-radius: 6px !important;
        background-color: #fff !important;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22) !important;
        font-size: 16px !important;
        font-weight: 700 !important;
        color: #005cbc !important;
    }
    // .capSulesList li:nth-child(n+5), .currencyList li:nth-child(n+5){display: none;}
    .viewMore{ 
        text-align: center !important; 
        margin-top: 20px !important;
    }
    .viewMore__cta {
        font-size: 16px !important;
        font-weight: 700 !important;
        color: #005cbc !important;
    }
    .faqList {
        margin-top: 50px !important;
    }
    .faqList li{ 
        border-radius: 6px !important; 
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22) !important; 
        background-color: #fff !important; 
        padding: 20px 10px !important; 
        margin-bottom: 40px !important;
        border: none !important;
    }
    .faqList li:last-child{ margin-bottom: 0 !important;}
    .faqList li:hover { 
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22) !important;
        border-color: transparent !important;
    }
    .faqList li:hover h4.question{ 
        border-radius: unset !important; 
        box-shadow: unset !important; 
        background-color: unset !important;
    }
    .faqList li h4.question{ 
        padding: 0 60px 0 0 !important; 
        font-size: 18px !important; 
        line-height: 22px !important;
        font-weight: 900 !important;
        color: #000 !important;
    }
    .faqList li h4.question::after{ 
        padding: 4px !important; 
        right: 10px !important; 
        top: 5px !important;
        border: solid #2f2f2f !important;
        border-width: 0 3px 3px 0 !important;
        padding: 6px !important;
        margin-top: 0 !important;
    }
    .faqList li.toggleAnswer h4.question::after{ 
        top: 10px !important;
        transform: rotate(-135deg) !important;
    }
    .faqList li div.answer{ 
        margin-bottom: unset !important; 
        padding: 10px 0 0 0 !important; 
        font-size: 16px !important;
        color: #000 !important;
    }
    .faqList li.active{ box-shadow: unset !important;}
    .pageContent{ margin-bottom: 0;}
    .footernavCont{ grid-template-columns: repeat(2, 1fr);}
    .footerBottom{ text-align: left;}

    footer .footernavCont{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
        width: 100%;
        padding: 0 16px;
      }
      .reviewedCurrencies{
        padding: 30px 16px;
      }
      .reviewedCurrencies .container{
        flex-direction: column;
      }
  
      .reviewedCurrencies h3{
        margin-bottom: 0;
        line-height:1.3;
      }
  
      .footerLinkCol{
        margin-left:0;
      }

      footer {
        background-color: #000;
        padding: 46px 30px 46px;
      }
      
      footer .container {
        margin-top: 0;
        color: #fff;
        font-size: 16px;
        flex-direction: column;
      }  
      footer .item{
        margin-bottom: 50px;
      }
      footer a {
        font-size: 16px;
        color: #fff;
      }
      
      footer .linkTitle {
        margin-bottom: 20px;
        font-size: 20px;
        line-height: 20px;
      }
      .footerNavList li{
        margin-bottom: 0;
      }
}

/* Ipad and above */
@media (min-width: 768px) and (max-width: 1280px) {
  ${(props) =>
    props.deviceType !== "lg"
      ? `
    header{ padding: 10px 16px;}
    .heroSection{ padding: 0 16px;}
    .heroContent__left{ width: 48%;}
    .heroContent__right{ width: 48%;}
    .pageContainer{ margin: 30px auto; padding: 0 16px;}
    .convertCurrency{ padding: 20px 30px;}
    .forexServices__itemHdr{ flex-direction: column;}
    .conversionRate{ gap: 30px;}
    .capSulesList.grid5, .capSulesList.grid4{ 
        grid-template-columns: repeat(3, 1fr) !important;
        gap: 16px !important;
    }
    .capSulesList li {
        padding: 16px 18px !important;
        background-color: #fff !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        color: #005cbc !important;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22) !important;
    }
    .currencyList.grid5, .currencyList.grid4{ 
        grid-template-columns: repeat(3, 1fr) !important;
        gap: 16px !important;
    }
    .currencyList li a {
        padding: 14px 16px !important;
        background-color: #fff !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        color: #005cbc !important;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.22) !important;
        border: none !important;
        border-radius: 6px !important;
        min-height: auto !important;
    }
    .currency__icon {
        width: 40px !important;
        margin-right: 10px !important;
    }
    .currency__icon img {
        width: 40px !important;
        height: 40px !important;
    }
    .currencyList{ grid-template-columns: repeat(3, 1fr);}
    .faqList li {
        border-radius: 8px !important;
        margin-bottom: 24px !important;
        padding: 16px !important;
        border: 1px solid #E5E5E5 !important;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1) !important;
    }
    .faqList li h4.question{ 
        padding: 16px 50px 16px 0 !important;
        font-size: 18px !important;
        line-height: 24px !important;
        font-weight: 700 !important;
    }
    .faqList li h4.question::after {
        right: 16px !important;
        top: 50% !important;
        margin-top: -6px !important;
    }
    .faqList li div.answer {
        padding: 12px 0 0 0 !important;
        font-size: 15px !important;
        line-height: 22px !important;
    }
    footer{ padding: 30px 16px;}
  `
      : ""}
}
`;
